import Vue from 'vue'
import Vuex from 'vuex'
import authModule from './auth.js'
import newsModule from './news.js'
import userModule from './user.js'
import imgModule from './imgs.js'
import teamModule from './team.js'
import teamReportModule from './team-report'
import teamTreasuryModule from './team-treasury'
import mrModule from './match-report.js'
import playerModule from './player.js'
import playerReportModule from './player-report.js'
import rankingModule from './ranking.js'
import matchWeekModule from './match-week.js'
import playerUpgradeModule from './player-upgrade.js'
import skillModule from './skills.js'
import commentModule from './comment.js'
import leagueModule from './league.js'
import hmiModule from './hmi.js'
import pageModule from './page.js'
import notifModule from './notification.js'
import contentTypeModule from './content-type.js'
import refDatasModule from './ref_data.js'
import pollModule from './poll.js'
import seasonBreakInfosModule from './season-break-infos.js'

Vue.use(Vuex)

// A Vuex instance is created by combining the state, mutations, actions,
// and getters.
export default new Vuex.Store({
  modules: {
    auth: authModule,
    user: userModule,
    img: imgModule,
    news: newsModule,
    team: teamModule,
    matchReport: mrModule,
    player: playerModule,
    playerReport: playerReportModule,
    teamReport: teamReportModule,
    teamTreasury: teamTreasuryModule,
    ranking: rankingModule,
    matchWeek: matchWeekModule,
    playerUpgrade: playerUpgradeModule,
    skill: skillModule,
    comment: commentModule,
    league: leagueModule,
    hmi: hmiModule,
    page: pageModule,
    notification: notifModule,
    contentType: contentTypeModule,
    refDatas: refDatasModule,
    poll: pollModule,
    seasonBreakInfos: seasonBreakInfosModule
  }
})



// WEBPACK FOOTER //
// ./src/store/index.js